
import { Link } from "react-router-dom";


export default function Account({account, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={account.photo !== null ? account?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{account?.nom} {account?.prenom}</div>
                        <div className="widget-subheading">{account?.email}</div>
                    </div>
                </div>
            </td>
            <td>{account?.login}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (account?.etat === 2) ? 'badge-danger' :
                        (account?.etat === 1) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {account?.etatdef !== null ? account?.etatdef : "Etat compte"}
                </div>
            </td>
            {/* <td><ReactTimeAgo date={Date.parse(account?.datecrea)} timeStyle="facebook" /></td> */}
            <td className="text-center">
                <Link to={`/account/${account?.code}`} data-toggle="tooltip" title="View account" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}